const ALLOWED_IMAGE_MIME_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/avif',
]);

const ALLOWED_IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'webp', 'gif', 'avif']);

export const MAX_IMAGE_UPLOAD_BYTES = 5 * 1024 * 1024;

function sanitizePathSegment(segment: string): string {
  return segment
    .trim()
    .replace(/[^a-zA-Z0-9._-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^[-.]+|[-.]+$/g, '');
}

export function normalizeStoragePath(path: string): string {
  const normalized = path.replace(/\\/g, '/');
  const segments = normalized
    .split('/')
    .map((segment) => sanitizePathSegment(segment))
    .filter((segment) => segment.length > 0 && segment !== '.' && segment !== '..');

  return segments.join('/');
}

export function validateImageUploadFile(file: File):
  | { ok: true; normalizedName: string }
  | { ok: false; error: string } {
  if (!file) {
    return { ok: false, error: 'No image file was provided.' };
  }

  const normalizedName = sanitizePathSegment(file.name || 'upload');
  if (!normalizedName) {
    return { ok: false, error: 'Image filename is invalid.' };
  }

  if (!ALLOWED_IMAGE_MIME_TYPES.has(file.type)) {
    return { ok: false, error: 'Only JPG, PNG, WebP, GIF, and AVIF images are allowed.' };
  }

  if (!Number.isFinite(file.size) || file.size <= 0) {
    return { ok: false, error: 'Image file is empty or invalid.' };
  }

  if (file.size > MAX_IMAGE_UPLOAD_BYTES) {
    return { ok: false, error: 'Image file is too large. Maximum size is 5 MB.' };
  }

  const extension = normalizedName.split('.').pop()?.toLowerCase() || '';
  if (!extension || !ALLOWED_IMAGE_EXTENSIONS.has(extension)) {
    return { ok: false, error: 'Unsupported image file extension.' };
  }

  return { ok: true, normalizedName };
}
